import { Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { useMemo } from "react";
import { formatMoney } from "infra/helpers/number";
import { TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow } from "./../helper/util";
import { ColumnsType } from "antd/es/table/interface";

function useTabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualColumns(
  ano: string
) {
  return useMemo(() => {
    return (
      [
        {
          title: "Categoria",
          fixed: true,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text
              lineHeight={"20px"}
              fontSize={14}
              color={original.hasChildren ? colors.black : colors.black700}
              fontWeight={
                original.totalRow ||
                !Number.isFinite(original.valor) ||
                original.hasChildren
                  ? "bold"
                  : undefined
              }
              pl={original.nivel ? original.nivel * 4 : 0}
            >
              {original.breadcrumb} {original.nome}
            </Text>
          ),
        },
        {
          title: "Total",
          fixed: true,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text lineHeight={"20px"} fontSize={14} color={colors.black700}>
              {Number.isFinite(original.valor)
                ? formatMoney(original.valor)
                : ""}
            </Text>
          ),
        },
        {
          title: "Média",
          fixed: true,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => {
            const _media = original.totalRow
              ? original.mediaTotal
              : original.media;
            return (
              <Text lineHeight={"20px"} fontSize={14} color={colors.black700}>
                {Number.isFinite(_media) ? formatMoney(_media) : ""}
              </Text>
            );
          },
        },
        {
          title: `Jan/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-0"])
                ? formatMoney(original["mes-0"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Fev/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-1"])
                ? formatMoney(original["mes-1"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Mar/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-2"])
                ? formatMoney(original["mes-2"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Abr/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-3"])
                ? formatMoney(original["mes-3"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Mai/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-4"])
                ? formatMoney(original["mes-4"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Jun/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-5"])
                ? formatMoney(original["mes-5"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Jul/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-6"])
                ? formatMoney(original["mes-6"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Ago/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-7"])
                ? formatMoney(original["mes-7"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Set/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-8"])
                ? formatMoney(original["mes-8"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Out/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-9"])
                ? formatMoney(original["mes-9"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Nov/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-10"])
                ? formatMoney(original["mes-10"])
                : ""}
            </Text>
          ),
        },
        {
          title: `Dez/${ano}`,
          render: (
            original: TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow
          ) => (
            <Text>
              {Number.isFinite(original["mes-11"])
                ? formatMoney(original["mes-11"])
                : ""}
            </Text>
          ),
        },
      ] as ColumnsType<any>
    ).map((item, index) => ({
      ...item,
      width: index > 0 ? "150px" : "400px",
      align: index > 0 ? ("right" as any) : ("left" as any),
    }));
  }, [ano]);
}

export default useTabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualColumns;
